import { EQueryStringFilters } from '../types/queryStringFilters';

export const qsKeyAsQSFilter = {
  [EQueryStringFilters.Cities]: EQueryStringFilters.Cities,
  [EQueryStringFilters.Departments]: EQueryStringFilters.Departments,
  [EQueryStringFilters.Specializations]: EQueryStringFilters.Specializations,
  [EQueryStringFilters.Tags]: EQueryStringFilters.Tags,
  [EQueryStringFilters.WorkFormats]: EQueryStringFilters.WorkFormats,
};
